import React, { useContext, useRef } from 'react';
import Modal from 'react-bootstrap/Modal';
import Slider from 'react-slick';
import toast from 'react-hot-toast';
import { businessContext } from '../../../UseContext/BusinessContext';


const AddJobPopup = () => {

  const {
    showAddJobPopup, setShowAddJobPopup,
    job, setJob,
    jobImages, setJobImages,
    createJob,
  } = useContext(businessContext);

  const fileInputRef = useRef(null);

  // handle click
  const handleDivClick = () => {
    fileInputRef.current.click();
  };

  // handle file change
  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);

    if((jobImages.length + files.length) <= 5) {
      setJobImages((prevImages) => [...files, ...prevImages]);
    } else {
      toast.error(`You can only select 5 images`);
    };
  };

  // handle input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setJob((prevProduct) => ({
      ...prevProduct,
      [name]: value,
    }));
  };

  // handle remove file
  const handleRemoveFile = (fileIndex) => {
    setJobImages((prevImages) => prevImages.filter((_, index) => index !== fileIndex));
  };

  const settings = {
    dots: true,           
    infinite: false,
    speed: 500,           
    slidesToShow: 1,        
    slidesToScroll: 1,        
    adaptiveHeight: true,     
  };

  
  return (
    <>
      <Modal show={showAddJobPopup} onHide={() => setShowAddJobPopup(false)} keyboard={false} className="create-post" backdrop="static" centered>
        <Modal.Header closeButton>&nbsp;</Modal.Header>
        <Modal.Body>
          <h4 className='text-center mb-4'>Add Job</h4>

          {/* Images */}
          <>
            {
              jobImages && jobImages.length > 0
              ?
              <div className='mb-3'>
                {/* Add */}
                <>
                  {
                    jobImages.length < 5
                    &&
                    <div className='p-1 bg-secondary-subtle rounded-circle d-inline-block mb-2 pt-0' onClick={handleDivClick}>
                      <img src="/images/business/icons/add-circle.svg" style={{ height: '20px' }} alt="add" />

                      <input type="file" ref={fileInputRef} style={{ display: 'none' }} onChange={handleFileChange} accept='image/*' multiple />
                    </div>
                  }
                </>

                <Slider className="job-images-slider" {...settings}>
                  {
                    jobImages.map((image, index) => (
                      <div className="border position-relative rounded-3" key={index}>
                        <img src={URL.createObjectURL(image)} className="rounded-3 object-fit-contain" style={{ maxHeight: '25vh', width: '100%' }} alt={`Product ${index}`} />

                        <div className='position-absolute top-0 end-0 mt-3 me-3 p-1 rounded-3 shadow-sm' style={{ backgroundColor: '#4b4b4b96' }} onClick={() => handleRemoveFile(index)}>
                          <img src="/images/icons/delete-white.svg" style={{ height: '20px' }} alt="delete" />
                        </div>
                      </div>
                    ))
                  }
                </Slider>
              </div>
              :
              <div className='d-flex flex-column align-items-center w-75 mx-auto rounded-3 py-4 mb-5 cursor-pointer' style={{ border: '1px dashed gray' }} onClick={handleDivClick}>
                <img src={`/images/business/icons/upload-photo-blue.svg`} style={{ height: '80px' }} alt="upload-blue" />

                <small className='text-primary'>Upload</small>
                <small className='text-secondary'>or</small>
                <small>Drop your file here</small>

                <input type="file" ref={fileInputRef} style={{ display: 'none' }} onChange={handleFileChange} accept='image/*' multiple />
              </div>
            }
          </>

          {/* Title */}
          <small className='text-secondary'>Title</small>
          <input type="text" className='form-control border-0 border-bottom shadow-none mb-4' name='title' value={job.title} onChange={handleInputChange} placeholder='Title...' />

          {/* Description */}
          <small className='text-secondary'>Description</small>
          <textarea class="form-control border-0 border-bottom shadow-none mb-4" name='description' value={job.description} onChange={handleInputChange} placeholder='Description...'></textarea>

          {/* Salary */}
          <small className='text-secondary'>Salary</small>
          <input type="text" className='form-control border-0 border-bottom shadow-none mb-4' name='salary' value={job.salary} onChange={handleInputChange} placeholder='Salary...' />

          {/* Experience */}
          <small className='text-secondary'>Experience</small>
          <select className="form-select border-0 border-bottom shadow-none mb-4" name='experience'
            value={job.experience} onChange={handleInputChange}
          >
            <option value="fresher">Fresher</option>
            <option value="expert">Expert</option>
            <option value="pro">Pro</option>
          </select>

          {/* Add */}
          <div className='text-center'>
            <button type="button" className='btn btn-primary w-50 rounded-pill' onClick={createJob}
              disabled={jobImages.length === 0 || job.title === '' || job.description === '' || job.salary === '' || job.experiences === ''}
            >Add</button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default AddJobPopup;